import { isMaybeIncognitoComet } from '#pplx/frontend/apps/ask/comet-shared/cometUtils.js';
import { onFloatingComponentProhibitedPath } from '#pplx/frontend/apps/ask/hooks/eppo-hooks/onFloatingComponentProhibitedPath.js';
import { FLOATING_SIGNUP_STATE_CHANGE_EVENT } from '#pplx/frontend/apps/ask/signup/floatingUpsellEvents.js';
import { SIGNUP_BANNER_DISMISSED_KEY } from '#pplx/frontend/apps/ask/signup/signupBannerDismissed.js';
import { useSessionStorage } from '#pplx/frontend/browser-storage/hooks/useSessionStorage.js';
import { usePathname } from '#pplx/frontend/router/usePathname.js';
import { noop } from 'lodash-es';
import { useCallback, useEffect, useReducer } from 'react';
export function useShouldShowFloatingSignup() {
    const pathname = usePathname();
    const onProhibitedPath = onFloatingComponentProhibitedPath(pathname);
    const isComet = isMaybeIncognitoComet();
    const [dismissed, setDismissed, getDismissed] = useSessionStorage(SIGNUP_BANNER_DISMISSED_KEY, false);
    const [, forceRefresh] = useReducer((value) => value + 1, 0);
    const isCometHomepage = isComet && pathname?.startsWith('/b/home');
    const setShow = useCallback((show) => {
        setDismissed(!show);
    }, [setDismissed]);
    useEffect(() => {
        const handleFloatingSignupStateChange = () => {
            setDismissed(getDismissed());
            forceRefresh();
        };
        window.addEventListener(FLOATING_SIGNUP_STATE_CHANGE_EVENT, handleFloatingSignupStateChange);
        return () => window.removeEventListener(FLOATING_SIGNUP_STATE_CHANGE_EVENT, handleFloatingSignupStateChange);
    }, [getDismissed, setDismissed]);
    if (onProhibitedPath && !isCometHomepage) {
        return [false, noop];
    }
    return [!dismissed, setShow];
}
//# sourceMappingURL=useShowFloatingSignup.js.map